import {
  ComputerOutlined,
  GroupsOutlined,
  PermMediaOutlined,
  PhoneCallbackOutlined,
  PlayCircleOutlined,
} from '@mui/icons-material';
import type { ReactNode } from 'react';
import { PRODUCT_KEYS } from '@/types/dtos/orders/response/product.dto.ts';
import { getProductCatalogEntry } from '@/constants/product-catalog.ts';

const catalogProductKeyToIcon: Record<string, ReactNode> = {
  [PRODUCT_KEYS.DATA_TRANSFER_GB]: <PermMediaOutlined sx={{ fontSize: '1.2rem', color: 'white' }} />,
  [PRODUCT_KEYS.CONTRIBUTOR]: <GroupsOutlined sx={{ fontSize: '1.3rem', color: 'white' }} />,
  [PRODUCT_KEYS.EVENT_CONTRIBUTOR]: <GroupsOutlined sx={{ fontSize: '1.3rem', color: 'white' }} />,
  [PRODUCT_KEYS.EVENT_REMOTE_SPEAKER_DAY]: <PhoneCallbackOutlined sx={{ fontSize: '1.2rem', color: 'white' }} />,
  [PRODUCT_KEYS.PLAY_RUN]: <PlayCircleOutlined sx={{ fontSize: '1.2rem', color: 'white' }} />,
  [PRODUCT_KEYS.VM_USE]: <ComputerOutlined sx={{ fontSize: '1.2rem', color: 'white' }} />,
};

export function getProductCatalogQuotaIcon(productKey: string | undefined): ReactNode | undefined {
  if (!productKey || !getProductCatalogEntry(productKey)) return undefined;
  return catalogProductKeyToIcon[productKey];
}
